<template>
  <div :class="['white-button', widthClass]" class="position-relative">
    <b-button
      :disabled="disabled"
      @click.stop="$emit('clicked'), $event.target.blur()"
      class="rounded-pill"
    >
      {{ text }}

      <!-- <div class="upload-loader-pos" v-show="">
      <Loader />
    </div> -->
    </b-button>
  </div>
</template>

<script>
export default {
  name: "OutlineButton",

  props: {
    text: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    widthClass: {
      type: String,
      default: "button-fit-content",
    },
  },
};
</script>

<style>
.purchase-btn button {
  width: 100% !important;
  height: 42px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.upload-loader-pos {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
.white-button .btn-secondary {
  background-color: var(--color-white);
  border: 1px solid var(--primary-blue);
  color: var(--primary-blue);
  padding: 0.25rem 1.125rem;
  font-family: "Montserrat", sans-serif;
  font-size: var(--size-13);
  font-weight: var(--weight-M);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3125rem;
  width: 100%;
}

/* .white-button .btn-secondary:focus, */
.white-button .btn-secondary:hover {
  box-shadow: 0px 0px 0px 0px rgba(32, 99, 155, 0.2),
    2px 3px 7px 0px rgba(32, 99, 155, 0.2),
    7px 10px 12px 0px rgba(32, 99, 155, 0.17),
    44px 63px 22px 0px rgba(32, 99, 155, 0);
}

.white-button .btn-secondary:focus {
  border: 1px solid var(--primary-blue);
  color: var(--primary-blue);
  box-shadow: none;
}

.white-button .btn-secondary:focus {
  border: 1px solid var(--primary-blue);
  color: var(--primary-blue);
  box-shadow: none;
}

.white-button .btn-secondary:disabled {
  /* 
	color: #aaaaaa;
	border: 1px solid #aaaaaa; */
  opacity: 0.5;
  box-shadow: none;
}

.white-button .btn-secondary:not(:disabled):not(.disabled):active,
.white-button .btn-secondary:not(:disabled):not(.disabled).active,
.white-button .show > .btn-secondary.dropdown-toggle {
  color: var(--primary-blue);
  background-color: var(--color-white);
  border-color: var(--primary-blue);
  box-shadow: none;
}

.button-width {
  width: 5.625rem;
}

.button-fit-content {
  width: fit-content;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .btn-outline-secondary.dropdown-toggle {
  color: var(--primary-blue);
  background-color: var(--color-white);
  border-color: var(--primary-blue);
}
.btn-outline-secondary:focus,
.btn-outline-secondary.focus {
  box-shadow: unset;
}
.h-33px button {
  height: 33px !important;
}
.h-34px button {
  height: 34px !important;
}
.w-100px .btn-secondary {
  width: 100px !important;
}
</style>
